import { Component, Input, OnInit } from '@angular/core';

import { WEBHOOK_STATUS, WebhookLog } from '../../models/call-history.model';

@Component({
  selector: 'app-webhook-list',
  templateUrl: './webhook-list.component.html',
  styleUrls: ['./webhook-list.component.scss'],
})
export class WebhookListComponent implements OnInit {
  @Input() private webhooks: WebhookLog[] = [];
  public webhooksGroupedByRuleName: Record<string, WebhookLog[]> = {};
  public webhookStatuses = WEBHOOK_STATUS;

  ngOnInit(): void {
    this.groupByRuleName();
  }

  private groupByRuleName(): void {
    this.webhooksGroupedByRuleName = this.webhooks.reduce(
      (result, item) => {
        const key = item.rule_name || 'deleted';
        if (!result[key]) {
          result[key] = [];
        }
        result[key].push(item);

        return result;
      },
      {} as Record<string, WebhookLog[]>
    );
  }
}
